import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import polyline from 'polyline';
import {debounce} from 'lodash'
import {
  postAddReservation,
  patchupdateReservation,
  getReservationDetails,
  clearReservationDetails,
  getAirportTerminalList,
} from 'redux/actions/reservationAction';
import {
  clearCompanyDetails,
  fetchCompanyDetails,
  fetchCompanyList,
  fetchParentCompanys,
} from 'redux/actions/companyAction';
import { clearEmployeesList, getEmployeesList } from 'redux/actions/EmployeesAction';
import {
  clearDirectionValue,
  clearPlaceDetails,
  getAutoComplete,
  getDirection,
  getGeocode,
  getPlaceDetails,
} from 'redux/actions/UserGoogleMap';
import { clearCompanyDuty, clearCompanyLocation, getRateCard, getTripPrice } from 'redux/actions/UserRateCard';
import { clearCar, getCar, getCarFacilities } from 'redux/actions/UserCar';
import { getCompanyDuty, getCompanyLocation } from 'redux/actions/UserRateCard';
import { getDateFormat, getReservationDetailsObject } from 'utils/utils';
import { tripDutyTypeEnum } from 'utils/enumObj';
import CommonMultiForm from 'components/commonMultiForm/CommonMultiForm';
import CommonButton from 'components/commonButton/CommonButton';
import ConfirmModal from 'components/confirmModal/ConfirmModal';
import BackDrop from 'components/backDrop/BackDrop';
import useModal from 'hooks/useModal';
import { reservationFormData,reservationEditFormData } from './ReservationData';
import { clearAutoComplete } from '../../redux/actions/UserGoogleMap';
import { getCountryCode } from 'redux/actions/authAction';
import { updateTripApi } from '../../services/TripService';
import AllotVehicleModal from 'pages/operation/allRides/AllotVehicleModal';
import { toast } from 'react-toastify';

const NewReservation = () => {
  const [isDisabled, setisDisabled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { open, toggle } = useModal();
  const { state } = location;
  const [currentLat, setCurrentLat] = useState('');
  const [currentLong, setCurrentLong] = useState('');
  const [defaultLocation, setDefaultLocation] = useState({});
  const [pickup, setPickup] = useState({});
  const [drop, setDrop] = useState({});
  const [landmark, setLandmark] = useState({});
  const [decodedPoints, setDecodedPoints] = useState();
  const [dutyTypeLabel, setDutyTypeLabel] = useState('');
  const [pickupLat, setPickupLat] = useState('');
  const [pickupLong, setPickupLong] = useState('');
  const [dutyType, setDutyType] = useState('');
  

  const [rateCardDetails, setRateCardDetails] = useState({
    companyId: '',
    dutyTypeId: '',
    vehicleCategoryId: '',
    location: '',
    locationName: '',
    contractId: '',
    rateCardId: ''
  });
  const reservationData = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );

  const airportTerminalList = useSelector((state) => state?.getAirportTerminalList?.airportTerminalList?.data);

  const airportTerminalOption = airportTerminalList?.body?.length > 0 && airportTerminalList?.body?.map((val) => {
    return { value: val?.id, label: `${val.terminal} ${val?.name}`, place_id: val.placeId };
  })


  const tripDetails = getReservationDetailsObject(reservationData);
  const { open: allotModal, toggle: setAllotModal } = useModal();
  const [updatedTripData, setUpdatedTripData] = useState(null);
  const selectedCompanyDetails = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );
  
  const companyList = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );
  const companyEmployeesList = useSelector(
    (state) => state?.getEmployeesList?.employeesList?.data?.body
  );

  const companyEmployeesLoader = useSelector((state) => state?.getEmployeesList?.loading);


  const parentCompanyList = useSelector(
    (state) => state?.parentCompanyList?.parentCompanyList?.body
  );
  const rateCard = useSelector(
    (state) => state?.userRateCard?.userRateCard?.data
  );
  const SelectedCarlist = useSelector((state) => state?.userCar?.userCar?.data);

  const SelectedCarlistLoader = useSelector((state) => state?.userCar?.loading);

  const selectedLocationList = useSelector(
    (state) => state?.userCompanyLocation?.userCompanyLocation?.data
  );

  const selectedLocationLoader = useSelector(
    (state) => state?.userCompanyLocation?.loading
  );

  const selectedDutyList = useSelector(
    (state) => state?.userCompanyDuty?.userCompanyDuty?.data
  );
  const selectedDutyListLoader = useSelector((state) => state?.userCompanyDuty?.loading);

  const companyBranch = selectedCompanyDetails?.branch

  const parentCompanyListOption = parentCompanyList?.map((val) => {
    return { value: val?.id, label: val?.name };
  });
  const employeeListOption = (companyEmployeesList?.length &&
    companyEmployeesList?.map((val) => {
      return {...val, value: val?.id, label: val?.email};
    })) || ['No Data Found'];

  const SelectedCarListOption =
    SelectedCarlist?.length > 0 ?
    SelectedCarlist?.map((val) => {
      return { value: val?.id, label: val?.carType, seater: val?.seater };
    }) : [];

  const dutyTypeOption = selectedDutyList?.map((val) => {
    return {
      value: val?.id,
      label: val?.name,
      id: val?.tripType,
    };
  });

  const companyBranchesOption =  companyBranch?.length && companyBranch?.map((val) => {
    return { value: val?.id, label: val?.address };
  });

  const companyListOption = companyList?.map((val, idx) => {
    return {
      value: val.id,
      label: val.name,
      companyemail: val?.email,
      parentCompanyName: val?.parentCompanyName,
      billingType: val?.Contracts?.[0]?.billingType,
      contractId: val?.Contracts?.[0]?.CompanyContracts?.ContractId,
      allowedDomains:val?.allowedDomain
    };
  });

  const cityOption = selectedLocationList?.map((val) => {
    return { value: val?.id, label: val?.name, geoPoint:val?.geoPoint };
  });

  const editRateCardPackage = [{
      value: tripDetails?.rateCardId,
      label: `${tripDetails?.slabTime}hr - ${tripDetails?.slabDistance}km`,
  }]

  const rateCardPackage = rateCard?.length > 0 ? rateCard.map((val) => {
    return {
      value: val?.id,
      label: val?.rateConfig?.name
    }
  }) : []


  const companyTableDataLoader = useSelector(
    (state) => state?.userCompany?.loading
  );

  const companyLoader = useSelector((state) => state?.userCompany?.loading);

  const reservationDetails = useSelector(
    (state) => state?.getReservationDetails?.loading
  );

  const locationData =
    useSelector(
      (state) => state.userAutoComplete?.userAutoComplete?.data);
  const currentLocationData =
    useSelector((state) => state.userGeocode?.userGeocode?.results) || [];
  const pickUpLatLngData = useSelector(
    (state) =>
      state?.userPlaceDetails?.pickup?.pickup?.data?.result?.geometry?.location
  );
  let dropLatLngData = useSelector(
    (state) =>
      state?.userPlaceDetails?.drop?.drop?.data?.result?.geometry?.location
  );
  let landmarkLatLngData = useSelector((state) => state?.userPlaceDetails?.landmark?.landmark?.data?.result?.geometry?.location);

  const directionDataPoints = useSelector(
    (state) => state?.userDirection?.userDirection?.data?.routes?.[0]?.legs?.[0]
  );

  const overviewPolyline = useSelector(
    (state) =>
      state?.userDirection?.userDirection?.data?.routes?.[0]?.overview_polyline
        ?.points
  );

  const locationDataLoader = useSelector((state) => state.userAutoComplete);

  const rateCardLoader = useSelector(
    (state) => state?.userRateCard?.loading
  );

  const countryCodeListResponse = useSelector((state) => state?.getCountryCode);
  const countryCodeListData = countryCodeListResponse?.countryCodeList?.data?.sort((a, b) => a.name.localeCompare(b.name))?.map((data) => {return {value: `+${data?.dialCode}`, label: `${data?.code} +${data?.dialCode}`}})

  useEffect(() => {
    if (overviewPolyline) {
      const decoded = polyline.decode(overviewPolyline);
      setDecodedPoints(decoded);
    }
  }, [overviewPolyline]);

  const companyListPayload = {
    search: '',
    page: 0,
    pageSize: "",
    status: 'Active',
    location: '',
    dateTo: '',
    dateFrom: '',
  };

  const employeeListPayload = {
    search: '',
    page: 0,
    pageSize: "",
    companyId: rateCardDetails?.companyId
  };

  useEffect(() => {
    const details = getReservationDetailsObject(state?.reservationProfile);
    dispatch(fetchCompanyList(companyListPayload));
    dispatch(fetchParentCompanys());
    dispatch(getCountryCode());

    if (state?.edit) {
      dispatch(getRateCard({ rateCardId: details?.companyId }));
      dispatch(getReservationDetails(state?.reservationProfile?.id));
      dispatch(fetchCompanyDetails({ id: state?.reservationProfile?.companyId }));
    }
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearReservationDetails());
      dispatch(clearCompanyDetails());
      setDecodedPoints([]);
      clearPlaceDetails();
      clearDirectionValue();
    };
  }, []);

  useEffect(() => {
    if (currentLocationData?.length > 0) {
      setDefaultLocation(currentLocationData[0]);
    }
  }, [currentLocationData]);

  // Fetch airport terminal list on edit mode when reservation data is loaded
  useEffect(() => {
    if (state?.edit && reservationData?.id && reservationData?.type) {
      dispatch(getAirportTerminalList({
        type: reservationData?.type,
        sourceAddress: reservationData?.location || reservationData?.sourceAddress
      }));
    }
  }, [state?.edit, reservationData?.id, reservationData?.type]);

  const onHandleChange = (event, value, name) => {
    if (name === 'pickUp' || name === "fromAirportTerminal") {
      setPickup(value);
    } else if (name === 'drop' || name === 'toAirportTerminal') {
      setDrop(value);
    } else if(name ==='landmark'){
      setLandmark(value)
    }
  };

  // ---PickUp Details---
  useEffect(() => {
    if (pickup?.place_id) {
      const data = {
        placeId: pickup?.place_id,
        type: 'pickUp',
      };
      dispatch(getPlaceDetails(data));
    }
  }, [pickup?.place_id]);

  // ---Drop Details---
  useEffect(() => {
    if (drop?.place_id) {
      const data = {
        placeId: drop?.place_id,
        type: 'drop',
      };
      dispatch(getPlaceDetails(data));
    }
  }, [drop?.place_id]);

   // ---Landmark Details---
   useEffect(() => {
    if (landmark?.place_id) {
      const data = {
        placeId: landmark?.place_id,
        type: 'landmark',
      };
      dispatch(getPlaceDetails(data));
    }
  }, [landmark?.place_id]);

  // ---Distance---
  useEffect(() => {
    if ((pickUpLatLngData || landmarkLatLngData) && dropLatLngData) {
      const data = {
        origin: pickUpLatLngData || landmarkLatLngData,
        destination: dropLatLngData,
      };
      dispatch(getDirection(data));
    }
  }, [pickUpLatLngData, dropLatLngData,landmarkLatLngData]);

  const onInputChangeVal = debounce((value, event) => {
      const data = {
      name: value,
      sessiontoken: '',
      location: pickupLat ? pickupLat + ',' + pickupLong : '',
      dutyType:dutyType,
      locationType: event?.target?.name
    };
    if(event?.type === 'change' && value){
    dispatch(getAutoComplete(data));
    }
  }, 1000);

  const onCompanyAutoSuggestion = debounce((event, value) => {
    if(event?.type === 'change') {
      if(value?.length) {
        dispatch(fetchCompanyList({...companyListPayload, search:value}));
      }
      else {
        dispatch(fetchCompanyList(companyListPayload));
      }
    }
   
  }, 500);

  const onEmployeeAutoSuggestion = debounce((event, searchedValue) => {
    if(event?.type === 'change' && rateCardDetails?.companyId) {
      if(searchedValue?.length) {
        dispatch(getEmployeesList({...employeeListPayload, search: searchedValue}));
      }
      else {
        dispatch(getEmployeesList(employeeListPayload)); 
      }
    }
  }, 500);

  const onCurrentAddress = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setCurrentLat(position?.coords?.latitude);
      setCurrentLong(position?.coords?.longitude);
      const data = {
        latlng: position?.coords?.latitude
          ? position?.coords?.latitude + ',' + position?.coords?.longitude
          : '',
      };
      dispatch(getGeocode(data));
    });
  };

  const fetchDutyType = (name, fieldValue) => {
    setPickupLat(fieldValue?.geoPoint?.coordinates?.[0]);
    setPickupLong(fieldValue?.geoPoint?.coordinates?.[1]);

    dispatch(clearAutoComplete());
    const payload = {
      location: fieldValue?.value,
      contractId: rateCardDetails?.contractId,
    };
    setRateCardDetails({...rateCardDetails, location: fieldValue?.value, locationName: fieldValue?.label});
    dispatch(getCompanyDuty(payload));
  };

  const fetchVehicle = (fieldValue) => {

    setDutyType(fieldValue?.id)
    const payload = {
      type: fieldValue?.id,
      loader: true,
      contractId: rateCardDetails?.contractId,
      location: rateCardDetails?.location,
    };
    dispatch(getAirportTerminalList({type: fieldValue?.id, sourceAddress: rateCardDetails?.locationName}))
    dispatch(getCar(payload));
  };

  //fetching Ratecard based on City, dutyType, vehicle
  const fetchRateCard = (name, value) => {
    const rateCardPayload = rateCardDetails;
    rateCardPayload[name] = value;
    setRateCardDetails(rateCardPayload);
    if (
      rateCardPayload?.contractId &&
      rateCardPayload?.dutyTypeId &&
      rateCardPayload?.vehicleCategoryId &&
      rateCardPayload?.location
    ) {
      dispatch(getRateCard(rateCardPayload));
    }
  };

  const fetchDetails = (fieldName, id, contractId) => {
    const rateCardPayload = rateCardDetails;
    rateCardPayload[fieldName] = id;
    setRateCardDetails(rateCardPayload);

    if(contractId) {
      dispatch(fetchCompanyDetails({ id: id }));
      dispatch(getEmployeesList({...employeeListPayload, companyId: id }));
      dispatch(getCompanyLocation(contractId));
    } else {
      dispatch(clearEmployeesList());
      dispatch(clearCompanyLocation());
      dispatch(clearCompanyDuty());
      dispatch(clearCar());
    }

  };

  const onScrollTop = () => {
    const element = document.getElementsByClassName('formDiv');
    element[0].scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

const submitData = (data, image, country) => {
  const parentCompanyId =
    parentCompanyListOption &&
    parentCompanyListOption?.filter(
      (obj) => obj?.label === data?.parentCompany
    );

  if (data?.dutyTypeId?.value) {
    setDutyTypeLabel(data?.dutyTypeId?.label);
  }

  const calcEta = directionDataPoints?.duration?.value
    ? (directionDataPoints?.duration?.value / 60 / 60)
    : 0;
  const calcDistance = directionDataPoints?.distance?.text
    ? (directionDataPoints?.distance?.value / 1000)
    : 0;

  const airportTransferType =
    data?.airportRideType === "To-Airport"
      ? data?.toAirportTerminal
      : data?.fromAirportTerminal;

  const airportTerminalAddress =
    airportTerminalOption?.length > 0 &&
    airportTerminalOption?.filter((obj) => obj.value === airportTransferType);

  const handleAddress = () => {
    let selectedAddress = {
      pickup: data?.pickUp || "",
      drop: data?.drop || ""
    };

    if (data?.dutyTypeId?.id === tripDutyTypeEnum.airpotTransfer) {
      if (data?.airportRideType === "To-Airport") {
        selectedAddress["drop"] = airportTerminalAddress?.[0]?.label || "";
      } else if (data?.airportRideType === "From-Airport") {
        selectedAddress["pickup"] = airportTerminalAddress?.[0]?.label || "";
      }
    }
    return { selectedAddress };
  };

  const dateTime = data?.scheduledTime?.['$d']
    ? getDateFormat(data?.scheduledTime?.['$d'], 'timeFormat')
    : getDateFormat(data?.scheduledTime, 'timeFormat') || '';
  
  // Format end date time for multi-day bookings
  const endDateTime = data?.endDateTime?.['$d']
    ? getDateFormat(data?.endDateTime?.['$d'], 'timeFormat')
    : getDateFormat(data?.endDateTime, 'timeFormat') || '';
  
  if (state?.edit) {
    // Handle airport terminal changes for source address
    let sourceAddress = data?.pickUp?.description ? data?.pickUp?.description : data?.pickUp || reservationData?.sourceAddress;
    if (data?.airportRideType === "From-Airport" && data?.fromAirportTerminal) {
      const matchedFromTerminal = airportTerminalOption?.find((obj) => obj.value === data?.fromAirportTerminal);
      sourceAddress = matchedFromTerminal?.label || data?.fromAirportTerminal;
    }

    // Handle airport terminal changes for destination address
    let destinationAddress = data?.drop?.description ? data?.drop?.description : data?.drop || reservationData?.destinationAddress;
    if (data?.airportRideType === "To-Airport" && data?.toAirportTerminal) {
      const matchedToTerminal = airportTerminalOption?.find((obj) => obj.value === data?.toAirportTerminal);
      destinationAddress = matchedToTerminal?.label || data?.toAirportTerminal;
    }

    const payload = {
      tripScheduledTime: dateTime,
      sourceAddress: sourceAddress,
      sourceLocation: pickUpLatLngData
        ? [pickUpLatLngData?.lat, pickUpLatLngData?.lng]
        : reservationData?.sourceLocation?.coordinates ? reservationData?.sourceLocation?.coordinates: [],
      destinationAddress: destinationAddress,
      destinationLocation: dropLatLngData
        ? [dropLatLngData?.lat, dropLatLngData?.lng]
        : reservationData?.destinationLocation?.coordinates ? reservationData?.destinationLocation?.coordinates : [],
    };

    // Add multi-day booking details if enabled
    if (data?.multiDayBooking && endDateTime) {
      payload.multiDay = JSON.stringify({
        startDate: dateTime,
        endDate: endDateTime,
      });
    }

    const tripId = reservationData?.uuid || reservationData?.id;

  updateTripApi(tripId, payload).then((res) => {
    if (res?.success === true || res?.code === 200) {
      const testResponse = {
        ...res
      };
      
      // Check if driver reallocation is required
      if (testResponse?.data?.driverReallocationRequired) {
        const transformedTripData = {
          id: testResponse?.data?.tripId,
          ...reservationData,
          ...testResponse?.data
        };
        setUpdatedTripData(transformedTripData);
        setAllotModal();
        navigate(-1);
      } else {
        navigate(-1);
      }

      toast.success('Trip details updated successfully');
    } else {
      toast.error(res?.data?.message || 'Failed to edit trip details')
      navigate(-1);
    }
  }).catch((error) => {
    toast.error('Failed to edit trip details')
    navigate(-1);
  });
  return;
}

// Add Flow
  if (isDisabled) {
    // ---------- Confirm/Add Flow ----------
    const formValue = {
      companyId: data?.companyId?.value,
      parentCompanyId: parentCompanyId?.[0]?.value || '',
      passengers: data?.noOfTravelers,
      carTypeId: data?.vehicleCategoryId?.value,
      isVip: data?.isVip || false,
      dutyTypeId: data?.dutyTypeId?.value,
      branchId: data?.employeeBranchId || data?.newBranch,
      note: data?.note,
      billingType:
        data?.billingType === 'billToIndividual'
          ? 1
          : data?.billingType === 'billToCompany'
          ? 2
          : '',
      bookingType: 2,
      location: data?.location?.value,
      scheduledTime: dateTime,
      bookedBy: data?.employeeEmail?.value || '',
      employeeId: data?.employeeEmail?.value || '',
      employeeName: data?.employeeName,
      employeeCountryCode: country?.value || country,
      employeePhoneNumber: data?.employeePhoneNumber,
      employeeEmail:
        data?.travellerDetails === 'new user'
          ? data?.newEmployee
          : data?.travellerDetails === 'guestUser'
            ? data?.email
            : data?.employeeEmail?.label,
      employeeCode: data?.employeeCode,
      departmentCode: data?.departmentCode,
      travelRequestNumber: data?.travelRequestNumber,
      eta: calcEta,
      distance: calcDistance,
      sourceAddress: handleAddress()?.selectedAddress?.pickup,
      destinationAddress: handleAddress()?.selectedAddress?.drop,
      sourceLandMarkAddress: data?.landmark,
      rateCardId: rateCard[0]?.id,
      needPlacard: data?.needPlacard || false,
      placardText: data?.placardText || '',
    };

    if (data?.pickUp || data?.fromAirportTerminal) {
      formValue['sourceLocation[0]'] = pickUpLatLngData?.lat || '';
      formValue['sourceLocation[1]'] = pickUpLatLngData?.lng || '';
    }
    if (data?.landmark) {
      formValue['sourceLandMarkLocation[0]'] = landmarkLatLngData?.lat || '';
      formValue['sourceLandMarkLocation[1]'] = landmarkLatLngData?.lng || '';
    }

    let formData = new FormData();
    formData.append('email', image);

    if (data?.drop || data?.toAirportTerminal || data?.fromAirportTerminal) {
      formData.append('destinationLocation[0]', dropLatLngData?.lat);
      formData.append('destinationLocation[1]', dropLatLngData?.lng);

      for (let i = 0; i < decodedPoints?.length; i++) {
        for (let j = 0; j < decodedPoints[i]?.length; i++) {
          formData.append(`polyLine[${i}][${j}]`, decodedPoints[i][j]);
          formData.append(
            `polyLine[${i}][${j + 1}]`,
            decodedPoints[i][j + 1]
          );
        }
      }
    }

    if (data?.guestDetails && data?.guestDetails?.length > 0) {
      for (let i = 0; i < data?.guestDetails?.length; i++) {
        formData.append(`guestDetails[${i}][name]`, data?.guestDetails[i]?.name);
        formData.append(`guestDetails[${i}][phone]`, data?.guestDetails[i]?.phone);
        formData.append(`guestDetails[${i}][countryCode]`, data?.guestDetails[i]?.countryCode);
      }
    }

    // Airport Transfer
    if (Number(data?.dutyTypeId?.id) === tripDutyTypeEnum.airpotTransfer) {
      formData.append('type', tripDutyTypeEnum.airpotTransfer);
      formData.append('tripType', data?.airportRideType);
      formData.append('airlineDetails', data?.airlineDetails);
      formData.append('flightNo', data?.flightNo);
      formData.append(
        'travelType',
        data?.airportRideType === 'To-Airport'
          ? 2
          : data?.airportRideType === 'From-Airport'
            ? 1
            : ''
      );
    }
    // Rental
    else if (Number(data?.dutyTypeId?.id) === tripDutyTypeEnum.rental) {
      formData.append('type', tripDutyTypeEnum.rental);
      formData.append('rateCardId', data?.package);
      
      // Add multi-day booking details if enabled
      if (data?.multiDayBooking && endDateTime) {
        formData.append('multiDay[startDate]', dateTime);
        formData.append('multiDay[endDate]', endDateTime);
      }
      
      // Add endDateTime to formData for reference
      // if (endDateTime) {
      //   formData.append('endDateTime', endDateTime);
      // }
    }
    // Outstation
    else if (Number(data?.dutyTypeId?.id) === tripDutyTypeEnum.roundTrip) {
      formData.append(
        'tripEndTime',
        data?.returnDate?.['$d']
          ? getDateFormat(data?.returnDate['$d'], 'timeFormat')
          : data?.returnDate || ''
      );
      formData.append('type', tripDutyTypeEnum.roundTrip);
      formData.append('tripType', 'RoundTrip');
    }

    Object.keys(formValue).map((val) => {
      formData.append(val, formValue[val]);
    });

    dispatch(postAddReservation(formData, toggle));
  } else {
    // ---------- Preview Flow ----------
    const getTripPayload = {
      startTime: data?.scheduledTime?.['$d']
        ? getDateFormat(data?.scheduledTime?.['$d'], 'timeFormat')
        : data?.scheduledTime || '',
      companyId: data?.companyId?.value
        ? data?.companyId?.value
        : rateCardDetails?.companyId
          ? rateCardDetails?.companyId
          : state?.reservationProfile?.companyId,
      carTypeId: state?.edit
        ? reservationData?.carTypeId
        : data?.vehicleCategoryId?.value,
      sourceAddress: handleAddress()?.selectedAddress?.pickup || "",
      destinationAddress: handleAddress()?.selectedAddress?.drop || "",
      sourceLandMarkAddress: data?.landmark,
      source:
        (pickUpLatLngData?.lat && pickUpLatLngData?.lng)
          ? JSON.stringify([pickUpLatLngData?.lat, pickUpLatLngData?.lng])
          : "",
      destination:
        (dropLatLngData?.lat && dropLatLngData?.lng)
          ? JSON.stringify([dropLatLngData?.lat, dropLatLngData?.lng])
          : "",
      branchId: data?.employeeBranchId || data?.newBranch,
      isBooking: true,
      landMark:
        (landmarkLatLngData?.lat && landmarkLatLngData?.lng)
          ? JSON.stringify([landmarkLatLngData?.lat, landmarkLatLngData?.lng])
          : '',
    };

    let payload = {
      rateCardId: rateCard[0]?.id
    };

    const dutyType = data?.dutyTypeId?.id;
    if (parseInt(dutyType) === tripDutyTypeEnum.airpotTransfer) {
      payload = {
        ...payload,
        ...getTripPayload,
        type: tripDutyTypeEnum.airpotTransfer,
        distance: calcDistance,
        eta: calcEta,
        travelType:
          data?.airportRideType === 'To-Airport'
            ? 2
            : data?.airportRideType === 'From-Airport'
              ? 1
              : ''
      };
    } else if (parseInt(dutyType) === tripDutyTypeEnum.rental) {
      payload = {
        ...payload,
        ...getTripPayload,
        type: tripDutyTypeEnum.rental,
        rateCardId: data?.package,
      };
      if (data?.drop) {
        payload = {
          ...payload,
          distance: calcDistance || tripDetails?.exactDistance,
          eta: calcEta || tripDetails?.duration,
        };
      }
      // Add multi-day booking details if enabled
      if (data?.multiDayBooking && endDateTime) {
        payload.multiDay = JSON.stringify({
          startDate: dateTime,
          endDate: endDateTime,
        });
      }
    } else if (parseInt(dutyType) === tripDutyTypeEnum.roundTrip) {
      payload = {
        ...payload,
        ...getTripPayload,
        tripEndTime: data?.returnDate?.['$d']
          ? getDateFormat(data?.returnDate['$d'], 'timeFormat')
          : data?.returnDate || '',
        type: tripDutyTypeEnum.roundTrip,
        distance: calcDistance || tripDetails?.exactDistance,
        eta: calcEta || tripDetails?.duration,
      };
    }

    if (
      data?.companyId?.value ||
      rateCardDetails?.companyId ||
      state?.reservationProfile?.companyId
    ) {
      dispatch(getTripPrice(payload));
      dispatch(getCarFacilities(getTripPayload?.carTypeId));
      setisDisabled(!isDisabled);
      onScrollTop();
    }
  }
};

  const handleBack = () => {
    if (isDisabled) {
      setisDisabled(!isDisabled);
    } else {
      navigate(-1);
    }
  };

  const bookingType = reservationData?.bookingType
  const editDefaultValues = {
    doc: tripDetails?.email,
    companyId: reservationData?.companyName,
    parentCompany: selectedCompanyDetails?.parentCompanyName,
    companyEmail: reservationData?.tripCompany?.email,
    employeeId: reservationData?.Employee?.id,
    employeeEmail: {
      label: reservationData?.Employee?.email,
      value: reservationData?.Employee?.email,
      id: reservationData?.Employee?.id,
    },
    employeeName: reservationData?.Employee?.name,
    phoneNumber: reservationData?.Employee?.phoneNumber,
    countryCode:  reservationData?.Employee?.countryCode,
    employeeCode: reservationData?.Employee?.employeeId || 'NA',
    departmentCode: reservationData?.Employee?.code || 'NA',
    employeeBranch: reservationData?.tripBranch?.address || 'NA',
    isVip: reservationData?.isVip,
    noOfTravelers: reservationData?.additionalInfo?.passengers || tripDetails?.passengers,
    guestPassengers: reservationData?.additionalInfo?.passengersDetails?.guestPassengers || [],
    travelRequestNumber: reservationData?.travelRequestNumber,
    package: tripDetails?.rateCardId,
    vehicleCategoryId: reservationData?.carType,
    vehicleSeater: tripDetails?.MasterCarType?.seater,
    dutyTypeId: reservationData?.dutyTypeName,
    dutyTypeOption: dutyTypeOption?.filter(
      (obj) => obj.value === tripDetails?.dutyTypeId
    ),
    airportRideType: 'To-Airport',
    tripType: reservationData?.type,
    airlineDetails: tripDetails?.airlineDetails,
    location: reservationData?.ServiceCity?.name,
    flightNo: reservationData?.additionalInfo?.flightDetails?.flightNo || tripDetails?.flightNo,
    scheduledTime: reservationData?.scheduledTime,
    returnDate: tripDetails?.tripEndTime,
     rateCardPackage : {
        value: tripDetails?.id,
        label: `${tripDetails?.slabTime}hr - ${tripDetails?.slabDistance}km`,
      },
    note: tripDetails?.note,
    
    billingType:
      tripDetails?.billingType === 1 ? 'billToIndividual' : 'billToCompany',
      toAirportTerminal: reservationData?.destinationAddress,
      toAirportTerminalList: [{
        value: reservationData?.destinationAddress,
        label: reservationData?.destinationAddress
      }],
      fromAirportTerminal: reservationData?.sourceAddress,
      fromAirportTerminalList: [{
        value: reservationData?.sourceAddress,
        label: reservationData?.sourceAddress
      }],
    pickUp: {
      description: reservationData?.sourceAddress,
      structured_formatting: {
        main_text: reservationData?.sourceAddress,
        secondary_text: reservationData?.sourceAddress,
      },
    },
    landmark: {
      description: tripDetails?.sourceLandMarkAddress,
      structured_formatting: {
        main_text: tripDetails?.sourceLandMarkAddress,
        secondary_text: tripDetails?.sourceLandMarkAddress,
      },
    },

    drop: {
      description: reservationData?.destinationAddress,
      structured_formatting: {
        main_text: reservationData?.destinationAddress,
        secondary_text: reservationData?.destinationAddress,
      },
    },
  };

  const billingType = (type) => {
    if (Number(type) === 1) {
      return 'billToIndividual';
    } else if (Number(type) === 2) {
      return 'billToCompany';
    } 
    else if (Number(type) === 3) {
      return '';
    }
  };

  const reservationDefaultValues = {
    travellerDetails: 'existing User',
    billingType: billingType(selectedCompanyDetails?.Contracts?.[0]?.billingType),
  };

  // Added condition for Quest Traveller
  const guestTraveller = !reservationData?.Employee?.employeeId;

  return (
    <Box>
      <Grid container className="ptb20">
        <Grid item xs={12} md={6} container alignItems={'center'}>
          <KeyboardArrowLeftRoundedIcon
            className="colorGrey font36"
            role="presentation"
            onClick={handleBack}
          />
          {!isDisabled && (
            <Typography variant="head3" className="colorBlack fw500">
              {state?.edit ? "Edit Reservation" : "Add A Reservation"}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          container
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          {isDisabled && (
            <CommonButton
              name="Edit"
              btnClass={'btnMedium'}
              iconType="edit"
              iconPlace="front"
              onClick={() => setisDisabled(!isDisabled)}
            />
          )}
        </Grid>
      </Grid>
      {!isDisabled && <Box className="dashedBorder"></Box>}
      <Grid
        container
        justifyContent={'center'}
        className="br20 bgLightWhite pb20"
      >
        <Grid item xs={11} md={11} className="mb20">
          {state?.edit ? (
            <>
              {!reservationDetails &&
              !companyTableDataLoader ? (
                <CommonMultiForm
                  formData={reservationEditFormData(
                    companyListOption,
                    employeeListOption,
                    state?.edit,
                    bookingType,
                    selectedCompanyDetails,
                    guestTraveller,
                  )}
                  editType={state?.edit}
                  agreementType={'reservation'}
                  onSubmittBtn={submitData}
                  // button={!isDisabled ? 'Preview & Confirm' : 'Confirm'}
                  button = "Update"
                  disabled={isDisabled}
                  formType={'reservation'}
                  defaultValues={editDefaultValues}
                  onHandleChange={onHandleChange}
                  onInputChangeVal={onInputChangeVal}
                  onCompanyAutoSuggestion={onCompanyAutoSuggestion}
                  onEmployeeAutoSuggestion={onEmployeeAutoSuggestion}
                  cityOption={cityOption}
                  billingType={selectedCompanyDetails?.Contracts?.[0]?.billingType}
                  locationData={locationData?.predictions || locationData?.results || []}
                  dutyTypeOption={dutyTypeOption}
                  companyEmployeeList={employeeListOption}
                  companyList={companyListOption}
                  rateCardPackage={rateCardPackage}
                  FareBreakUp={isDisabled}
                  dutyTypeLabel={dutyTypeLabel}
                  bookingBufferTime={airportTerminalList?.bookingBuffer}
                  countryCodeListData={countryCodeListData}
                  airportTerminalOption={airportTerminalOption}
                />
              ) : (
                <BackDrop />
              )}
            </>
          ) : (
                <CommonMultiForm
                  formData={reservationFormData(
                    dutyTypeOption,
                    SelectedCarListOption,
                    companyListOption,
                    employeeListOption,
                    selectedCompanyDetails,
                    state?.edit,
                    cityOption,
                  )}
                  editType={state?.edit}
                  agreementType={'reservation'}
                  onSubmittBtn={submitData}
                  button={!isDisabled ? 'Preview & Confirm' : 'Confirm'}
                  disabled={isDisabled}
                  formType={'reservation'}
                  companyList={companyListOption}
                  cityOption={cityOption}
                  SelectedCarListOption={SelectedCarListOption}
                  dutyTypeOption={dutyTypeOption}
                  dutyTypeIdLoader={{fieldType: "dutyTypeId", loader: selectedDutyListLoader}}
                  employeeEmailLoader={{fieldType: "employeeEmail", loader: companyEmployeesLoader}}
                  locationLoader={{fieldType: "location", loader: selectedLocationLoader}}
                  vehicleCategoryIdLoader={{fieldType: "vehicleCategoryId", loader: SelectedCarlistLoader}}
                  companyIdLoader={{fieldType: "companyId", loader: companyLoader}}
                  companyEmployeeList={employeeListOption}
                  defaultValues={reservationDefaultValues}
                  onInputChangeVal={onInputChangeVal}
                  onCompanyAutoSuggestion={onCompanyAutoSuggestion}
                  onEmployeeAutoSuggestion={onEmployeeAutoSuggestion}
                  locationData={locationData?.predictions || locationData?.results || []}
                  onCurrentAddress={onCurrentAddress}
                  fetchVehicle={fetchVehicle}
                  fetchDutyType={fetchDutyType}
                  fetchRateCard={fetchRateCard}
                  companyBranches={companyBranchesOption}
                  currentLat={currentLat}
                  currentLong={currentLong}
                  defaultAddress={
                    defaultLocation?.formatted_address
                      ? defaultLocation?.formatted_address
                      : {}
                  }
                  onHandleChange={onHandleChange}
                  companyDetails={fetchDetails}
                  companyData={selectedCompanyDetails}
                  billingType={selectedCompanyDetails?.Contracts?.[0]?.billingType}
                  rateCardPackage={rateCardPackage}
                  FareBreakUp={isDisabled}
                  dutyTypeLabel={dutyTypeLabel}
                  bookingBufferTime={airportTerminalList?.bookingBuffer}
                  airportTerminalOption={airportTerminalOption}
                  packageLoader={{fieldType: "package", loader: rateCardLoader}}
                  pickUpLoader={{fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading}}
                  landmarkLoader={{fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading}}
                  dropLoader={{fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading}}
                  countryCodeListData={countryCodeListData}
                  type={rateCardDetails.dutyTypeId}
                />
          )}
        </Grid>
      </Grid>
      <ConfirmModal open={open} toggle={toggle} navigate={navigate} />
    <AllotVehicleModal
  open={allotModal}
  toggle={() => {
    setAllotModal();
    // Reset updated trip data when modal closes
    setUpdatedTripData(null);
    // Navigate back after modal closes if it was opened from edit
    if (state?.edit && updatedTripData) {
      navigate(-1);
    }
  }}
  tripDetails={updatedTripData || tripDetails}
  page={'Reservation'}
/>
    </Box>
  );
};

export default NewReservation;
